import { API } from 'aws-amplify';
import * as types from './types';

export const getLabData = () => ({
  type: types.LOAD_LAB,
  payload: {
    promise: API.get('app', `utils/config`)
  }
});

export const getCatalog = () => ({
  type: types.LOAD_CATALOG,
  payload: {
    promise: API.get('app', `utils/catalogs`)
  }
});
